import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-slate-900/80 bg-slate-950/60 backdrop-blur-md">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <a href="/" className="flex items-center gap-2.5 mb-3">
              <img src="/Icon.png" alt="" className="h-7 w-7 rounded-lg" />
              <span className="text-white font-bold text-base tracking-tight">
                Valmate
              </span>
            </a>
            <p className="text-xs text-slate-500 leading-relaxed max-w-xs">
              Free instant property valuations for the UK, powered by Land
              Registry data. Made for estate agents.
            </p>
          </div>

          <FooterColumn title="For homeowners">
            <FooterLink href="/">Get a valuation</FooterLink>
            <FooterLink href="https://rehub.studio/faq">How it works</FooterLink>
            <FooterLink href="https://rehub.studio/privacy">
              How we use your data
            </FooterLink>
          </FooterColumn>

          <FooterColumn title="For agents">
            <FooterLink href="/">Sign up free</FooterLink>
            <FooterLink href="/pricing">Pricing</FooterLink>
            <FooterLink href="/" muted>
              Embed snippet · coming soon
            </FooterLink>
            <FooterLink href="https://rehub.studio">More ReHub tools</FooterLink>
          </FooterColumn>

          <FooterColumn title="Company">
            <FooterLink href="https://rehub.studio">About ReHub</FooterLink>
            <FooterLink href="https://rehub.studio/contact">Contact</FooterLink>
            <FooterLink href="https://rehub.studio/privacy">Privacy</FooterLink>
            <FooterLink href="https://rehub.studio/terms">Terms</FooterLink>
          </FooterColumn>
        </div>

        <div className="pt-6 border-t border-slate-900/80 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-500">
          <div>© 2026 ReHub Studio · All rights reserved</div>
          <div className="flex items-center gap-4">
            <span>Property data: HM Land Registry · Postcodes: postcodes.io</span>
          </div>
        </div>

        <div className="mt-4 text-[11px] text-slate-600 leading-relaxed max-w-3xl">
          Valuations are estimates based on public data and are not RICS
          valuations. For accurate, in-person valuations, ask a local estate
          agent. Estimates do not factor in current property condition,
          renovations, extensions, or local market conditions beyond recorded
          sales.
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <h4 className="text-[11px] uppercase tracking-wider font-semibold text-slate-400 mb-3">
        {title}
      </h4>
      <ul className="space-y-2">{children}</ul>
    </div>
  );
}

function FooterLink({
  href,
  children,
  muted = false,
}: {
  href: string;
  children: React.ReactNode;
  muted?: boolean;
}) {
  return (
    <li>
      <a
        href={href}
        className={`text-xs transition-colors inline-flex items-center gap-1 ${
          muted ? 'text-slate-600' : 'text-slate-400 hover:text-white'
        }`}
      >
        {children}
        {!muted && href === '/' && <ArrowRight size={11} />}
      </a>
    </li>
  );
}
